import { HttpErrorResponse } from '@angular/common/http';
import { IvCertCircuitDocumentP } from '../../../api';
import { AvailableOperationStatus } from './available-operation-status';
import { AvailableOperationTypes } from './available-operation-types';

export class OperationRequest {
  private _idOperation: string;
  private _hasOperationSupport: boolean = true;
  private _hasFinishCircuit: boolean = true;
  private _hasDeclineOperation: boolean;
  private _typeSignature: string;
  private _idDocument: string;
  private _operationType: AvailableOperationTypes;
  private _circuitName: string;
  private _state: number;
  private _documentTitle: string;
  private _idCircuit: string;
  private _validateCert: boolean = false;
  private _documentList: IvCertCircuitDocumentP[];
  private _hasError: boolean;
  private _error: HttpErrorResponse;
  private _hasAcceptTerms: boolean;
  private _hasCustomCheckbox: boolean;
  private _requiredLogin: boolean;
  private _acceptedCustomCheckbox: boolean = false;
  private _hasTokenSAML: boolean = false;
  private _automaticDownload: boolean = false;
  private _authPreferenceResponse: boolean;
  private _acceptedAuth: boolean = false;
  private _hasNextOperation: boolean = false;
  private _offShowIntroPage: boolean = false;

  get idOperation(): string {
    return this._idOperation;
  }

  set idOperation(value: string) {
    this._idOperation = value;
  }

  get offShowIntroPage(): boolean {
    return this._offShowIntroPage;
  }

  set offShowIntroPage(value: boolean) {
    this._offShowIntroPage = value;
  }

  get hasFinishCircuit(): boolean {
    return this._hasFinishCircuit;
  }

  set hasFinishCircuit(value: boolean) {
    this._hasFinishCircuit = value;
  }

  get hasOperationSupport(): boolean {
    return this._hasOperationSupport;
  }

  set hasOperationSupport(value: boolean) {
    this._hasOperationSupport = value;
  }

  get typeSignature(): string {
    return this._typeSignature;
  }

  set typeSignature(value: string) {
    this._typeSignature = value;
  }

  get hasDeclineOperation(): boolean {
    return this._hasDeclineOperation;
  }

  set hasDeclineOperation(value: boolean) {
    this._hasDeclineOperation = value;
  }

  get operationType(): AvailableOperationTypes {
    return this._operationType;
  }

  set operationType(value: AvailableOperationTypes) {
    this._operationType = value;
  }

  get circuitName(): string {
    return this._circuitName;
  }

  set circuitName(value: string) {
    this._circuitName = value;
  }

  get idDocument(): string {
    return this._idDocument;
  }

  set idDocument(value: string) {
    this._idDocument = value;
  }

  get state(): AvailableOperationStatus {
    return this._state;
  }

  set state(value: AvailableOperationStatus) {
    this._state = value;
  }

  get documentTitle(): string {
    return this._documentTitle;
  }

  set documentTitle(value: string) {
    this._documentTitle = value;
  }

  get idCircuit(): string {
    return this._idCircuit;
  }

  set idCircuit(value: string) {
    this._idCircuit = value;
  }

  get validateCert(): boolean {
    return this._validateCert;
  }

  set validateCert(value: boolean) {
    this._validateCert = value;
  }

  get documentList(): IvCertCircuitDocumentP[] {
    return this._documentList;
  }

  set documentList(value: IvCertCircuitDocumentP[]) {
    this._documentList = value;
  }

  get hasError(): boolean {
    return this._hasError;
  }

  set hasError(value: boolean) {
    this._hasError = value;
  }

  get error(): HttpErrorResponse {
    return this._error;
  }

  set error(value: HttpErrorResponse) {
    this._error = value;
  }

  get hasAcceptTerms(): boolean {
    return this._hasAcceptTerms;
  }

  set hasAcceptTerms(value: boolean) {
    this._hasAcceptTerms = value;
  }

  get hasCustomCheckbox(): boolean {
    return this._hasCustomCheckbox;
  }

  set hasCustomCheckbox(value: boolean) {
    this._hasCustomCheckbox = value;
  }

  get acceptedCustomCheckbox(): boolean {
    return this._acceptedCustomCheckbox;
  }

  set acceptedCustomCheckbox(value: boolean) {
    this._acceptedCustomCheckbox = value;
  }

  get requiredLogin(): boolean {
    return this._requiredLogin;
  }

  set requiredLogin(value: boolean) {
    this._requiredLogin = value;
  }

  get hasTokenSAML(): boolean {
    return this._hasTokenSAML;
  }

  set hasTokenSAML(value: boolean) {
    this._hasTokenSAML = value;
  }

  set automaticDownload(value: boolean) {
    this._automaticDownload = value;
  }

  get automaticDownload(): boolean {
    return this._automaticDownload;
  }

  set authPreferenceResponse(value: boolean) {
    this._authPreferenceResponse = value;
  }

  get authPreferenceResponse(): boolean {
    return this._authPreferenceResponse;
  }

  set acceptedAuth(value: boolean) {
    this._acceptedAuth = value;
  }

  get acceptedAuth(): boolean {
    return this._acceptedAuth;
  }

  set nextOperation(value: boolean) {
    this._hasNextOperation = value;
  }

  get nextOperation(): boolean {
    return this._hasNextOperation;
  }
}
